<mat-form-field>
  <mat-label>{{ title() }}</mat-label>
  <input matInput
    [formControl]="control()">

    @if (control().value) {
      <button mat-icon-button
        type="button"
        matSuffix
        (click)="copy()">
        <mat-icon>{{copyIconName}}</mat-icon>
      </button>
    }
    @if (control().errors) {
      <mat-error>
        {{getError()}}
      </mat-error>
    }
  </mat-form-field>
